import { render } from "./Loader.vue?vue&type=template&id=08a7fb6b"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"
script.render = render

export default script